import { createColumnHelper } from "@tanstack/react-table";
import { eachDayOfInterval, format, isSameDay } from "date-fns";
import { DateRange } from "react-day-picker";
import { useMemo } from "react";
import { ru } from "date-fns/locale";
import { ChevronDown, ChevronRight } from "lucide-react";
import { TestAdsTdProps } from "@/pages/commers/cards/commers.card.ads";
import { TransformCardData } from "@/pages/commers/cards/commers.card.rating";
import { formatNumber } from "@/lib/utils";

function isTransformCardData(row: TestAdsTdProps | TransformCardData): row is TransformCardData {
  return (row as TransformCardData).data !== undefined;
}
export const useAdsCardColumns = (dateRange: DateRange) => {
  const columnHelper = createColumnHelper<TestAdsTdProps | TransformCardData>();

  const datesInRange = useMemo(
    () =>
      eachDayOfInterval({
        start: dateRange.from as Date,
        end: dateRange.to as Date,
      }),
    [dateRange.from, dateRange.to]
  );

  const createColumns = (datesArr: Date[]) => {
    return datesArr.map((date) => {
      const formattedDate = format(date, "dd MMMM", { locale: ru });
      return columnHelper.display({
        id: formattedDate,
        header: formattedDate,
        cell: (info) => {
          const original = info.row.original;
          if (isTransformCardData(original)) {
            const match = original.data.find((entry) => isSameDay(entry.date, date));
            return match?.value ? formatNumber(match.value) : "-";
          }
          return "";
        },
      });
    });
  };

  const columns = [
    columnHelper.display({
      id: "params",
      header: "Параметры",
      enableSorting: false,
      enableHiding: false,
      cell: (info) => {
        if ("company" in info.row.original) {
          return (
            <div className="flex items-center">
              <span className="p-2">
                {!info.row.subRows && <ChevronRight className="text-accent" />}
                {info.row.subRows && info.row.subRows.length > 0 && info.row.getIsExpanded() ? (
                  <ChevronDown className="text-primary" />
                ) : (
                  <ChevronRight className="text-primary" />
                )}
              </span>
              <span className="whitespace-nowrap">{info.row.original.company}</span>
            </div>
          );
        } else {
          return <div className="whitespace-nowrap pl-5 text-left">{info.row.original.label}</div>;
        }
      },
    }),
    ...createColumns(datesInRange),
  ];

  return columns;
};
